import { ACTIVITY_TYPES, DEPARTMENTS } from '../enums/enums';

export default class ActivityCard {
	created_by;
	date_created: string;
	department: DEPARTMENTS;
	groupBy;
	group;
	icon: string;
	id: number;
	pictures;
	prod_id: number;
	subViewName;
	type: ACTIVITY_TYPES;
	viewInputs;
	viewName: string;
}
